import React from 'react';
import { SelectType } from './sections/SelectType';
import { CreditCardInfo } from './sections/Info';

export const CreditCardForm = () => (
	<>
		<SelectType />
		<CreditCardInfo />
	</>
);
